/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';

import JobsComponent from './Jobs';
import JobDetails from './JobDetails';

import { Switch, Redirect, Route } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute.jsx';

@observer
class App extends React.Component {
    render() {
        const { match } = this.props;
        return (
            <div>
                <Switch>
                    <PrivateRoute exact path={`${match.path}/`} component={JobsComponent} />
                    <PrivateRoute exact path={`${match.path}/details/:id/`} component={JobDetails} />
                    <Route render={() => <Redirect to={`${match.path}/`} />} />
                </Switch>
            </div>
        );
    }
}

// TODO why not wrappedComponent ?
App.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(App);
